export default __webpack_public_path__ + "media/images/logout-4f3ead8811cf407ef62584c4aabde21d.png";